export const convertIdToName = (dataId, dataset, fieldName) => {
  const convertedArr = dataset.filter(data => {
    return data.id === Number(dataId);
  });
  if (convertedArr[0]) {
    return convertedArr[0][fieldName];
  }
  return "";
};



// WEBPACK FOOTER //
// ./src/helpers/convertIdToName.js